export const enum ApplicationScreens {
  LOGIN = 'LOGIN',
  HOME = 'HOME'
}

export const DateFormats = {
  iso: 'YYYY-MM-DD',
  nl: 'DD-MM-YYYY',
  fr: 'DD/MM/YYYY',
  en: 'MM/DD/YYYY'
};

export const DateTimeFormats = {
  iso: 'YYYY-MM-DD HH:mm',
  nl: 'DD-MM-YYYY HH:mm',
  fr: 'DD/MM/YYYY HH:mm',
  en: 'MM/DD/YYYY HH:mm'
};

export enum Language {
  English = 'en-GB',
  Dutch = 'nl-BE',
  French = 'fr-BE'
}
